import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation("home");

  return (
    <section className="relative min-h-[60vh] md:min-h-[80vh] w-full overflow-hidden flex items-center">
      <img
        src="/img/08-white-pvc-window-frame.jpg"
        alt="Nederlandse bakstenen woning met kozijn detail"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-text/70 via-brand-text/50 to-brand-text/30"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-10 w-full py-16 md:py-0">
        <div className="max-w-full md:max-w-[60%]">
          <span className="inline-block bg-brand-yellow text-brand-text font-geist font-bold text-xs uppercase tracking-wider px-4 py-2 rounded-full mb-4 md:mb-6">
            {t("hero.pill")}
          </span>
          <h1 className="font-geist font-bold text-[32px] sm:text-4xl md:text-[80px] leading-[1.1] xl:leading-[1.2] text-white mb-4 md:mb-6">
            {t("hero.h1")}
          </h1>
          <p className="font-geist text-base md:text-[22px] text-white/90 leading-relaxed max-w-xl mb-8 md:mb-10">
            {t("hero.subhead")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#offerte"
              className="font-geist font-bold text-sm md:text-base bg-brand-yellow text-brand-text px-8 py-4 rounded-full text-center hover:bg-white transition-colors whitespace-nowrap"
            >
              {t("hero.ctaPrimary")}
            </a>
            <a
              href="tel:+31407987470"
              className="font-geist font-bold text-sm md:text-base bg-transparent text-white border-2 border-white px-8 py-4 rounded-full text-center hover:bg-white hover:text-brand-text transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
              {t("hero.ctaPhone")}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-4 md:right-10 z-10 bg-white/95 backdrop-blur-xl rounded-2xl p-5 md:p-6 shadow-xl hidden md:block">
        <div className="flex items-center gap-2 mb-1">
          <i className="ri-google-fill w-6 h-6 flex items-center justify-center text-brand-blue text-xl"></i>
          <span className="font-geist font-bold text-lg text-brand-text">{t("hero.reviews")}</span>
        </div>
        <div className="flex items-center gap-1">
          {[1, 2, 3, 4, 5].map((s) => (
            <i key={s} className="ri-star-fill w-4 h-4 flex items-center justify-center text-brand-yellow text-sm"></i>
          ))}
        </div>
      </div>
    </section>
  );
}